import { isEmpty } from "./global";

let highlightedItemId = 0;


export function reloadDatatable(datatableId, callback, maintainPage) {
    //PURPOSE: reloads the data in a given data table on demand. callback is optional; maintainPage determines whether the currently selected page is maintained
    //only attempt reload if when can find the datatable
    if ($(datatableId).length === 0) return false;

    if (callback !== null) {
        $(datatableId).DataTable().ajax.reload(callback, maintainPage);
    }
    else {
        $(datatableId).DataTable().ajax.reload(null, maintainPage);
    }
}

export function setHighlightedRow(rowId) {
    highlightedItemId = rowId;
}

export function highlightRow(tableSelector) {

    if (!isEmpty(highlightedItemId) && highlightedItemId !== 0) {

        //a row is intended to be highlighted briefly. find it by id, then highlight by adding and removing a class.
        var rowToHighlight = $(tableSelector).find(`tr[data-id='${highlightedItemId}']`);

        rowToHighlight.addClass('highlighted');
        highlightedItemId = null;

        setTimeout(function () {

            rowToHighlight.removeClass('highlighted');
        }, 200);
    }

}
